"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var tslib_1 = require("tslib");
/**
 * Created by wangtong on 2021/1/4
 */
var internal = tslib_1.__importStar(require("./internal"));
// @ts-ignore
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var convert_1 = require("./convert");
var Utils;
(function (Utils) {
    Utils.isEmpty = internal.isEmpty;
    Utils.deepCopy = internal.deepCopy;
    function uuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        return s.join("");
    }
    Utils.uuid = uuid;
    function print(value) {
        if (typeof value === "object") {
            value = JSON.stringify(value, null, 4);
        }
        console.log(value);
    }
    Utils.print = print;
    /**
     * 延迟一定时间
     * @param timeout，毫秒级时间戳
     * @returns Promise<void>
     */
    function delay(timeout) {
        return new Promise(function (resolve) {
            setTimeout(resolve, timeout);
        });
    }
    Utils.delay = delay;
    /**
     * 批量执行
     * @param params：参数
     * @param func：执行函数
     * @param count: 单次批量执行个数
     * @returns {Promise<void>}
     */
    function batchCall(params, func, count) {
        if (count === void 0) { count = 5; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params_split, i, _i, params_split_1, sub_params;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params_split = [];
                        i = -1;
                        params.forEach(function (value, index) {
                            if (index % count === 0) {
                                i += 1;
                                params_split.push([]);
                            }
                            params_split[i].push(value);
                        });
                        _i = 0, params_split_1 = params_split;
                        _a.label = 1;
                    case 1:
                        if (!(_i < params_split_1.length)) return [3 /*break*/, 4];
                        sub_params = params_split_1[_i];
                        return [4 /*yield*/, Promise.all(sub_params.map(function (param) { return func(param); }))];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    Utils.batchCall = batchCall;
    function untilNotEmpty(value) {
        var defaults = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            defaults[_i - 1] = arguments[_i];
        }
        if (!Utils.isEmpty(value)) {
            return value === null ? undefined : value;
        }
        for (var _a = 0, defaults_1 = defaults; _a < defaults_1.length; _a++) {
            var item = defaults_1[_a];
            if (!Utils.isEmpty(item)) {
                return item === null ? undefined : item;
            }
        }
    }
    Utils.untilNotEmpty = untilNotEmpty;
    function untilNotNull(value) {
        var defaults = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            defaults[_i - 1] = arguments[_i];
        }
        if (value !== null && value !== undefined) {
            return value;
        }
        for (var _a = 0, defaults_2 = defaults; _a < defaults_2.length; _a++) {
            var item = defaults_2[_a];
            if (item !== null && item !== undefined) {
                return item;
            }
        }
    }
    Utils.untilNotNull = untilNotNull;
    function untilNotUndefined(value) {
        var defaults = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            defaults[_i - 1] = arguments[_i];
        }
        if (value !== undefined) {
            return value === null ? undefined : value;
        }
        for (var _a = 0, defaults_3 = defaults; _a < defaults_3.length; _a++) {
            var item = defaults_3[_a];
            if (item !== undefined) {
                return item === null ? undefined : value;
            }
        }
    }
    Utils.untilNotUndefined = untilNotUndefined;
    function ifNotUndefined(value, else_value) {
        if (value === undefined) {
            return else_value;
        }
        else {
            return value;
        }
    }
    Utils.ifNotUndefined = ifNotUndefined;
    function ifNotNull(value, else_value) {
        if (value === undefined || value === null) {
            return else_value;
        }
        else {
            return value;
        }
    }
    Utils.ifNotNull = ifNotNull;
    function ifNotEmpty(value, else_value) {
        if (value === undefined || value === null || Utils.isEmpty(value)) {
            return else_value;
        }
        else {
            return value;
        }
    }
    Utils.ifNotEmpty = ifNotEmpty;
    function throttle(func, duration, thisVal) {
        var emitter = new rxjs_1.Subscriber();
        new rxjs_1.Observable(function (subscriber) {
            // @ts-ignore
            emitter = subscriber;
        }).pipe(operators_1.throttleTime(duration)).subscribe(function (payload) {
            func.apply(payload.thisVal, payload.args);
        });
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            emitter.next({
                thisVal: thisVal,
                args: args
            });
        };
    }
    Utils.throttle = throttle;
    function Throttle(duration) {
        var emitter = new rxjs_1.Subscriber();
        var observer = new rxjs_1.Observable(function (subscriber) {
            // @ts-ignore
            emitter = subscriber;
        })
            .pipe(operators_1.throttleTime(duration));
        return function (target, propertyKey, descriptor) {
            // 封装执行函数
            var method = descriptor.value;
            observer.subscribe(function (payload) {
                // @ts-ignore
                method.apply(payload.thisVal, payload.args);
            });
            // @ts-ignore
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                // @ts-ignore
                emitter.next({
                    thisVal: this,
                    args: args
                });
            };
            return descriptor;
        };
    }
    Utils.Throttle = Throttle;
    function debounce(func, duration, thisVal) {
        var emitter = new rxjs_1.Subscriber();
        new rxjs_1.Observable(function (subscriber) {
            // @ts-ignore
            emitter = subscriber;
        }).pipe(operators_1.debounceTime(duration)).subscribe(function (payload) {
            func.apply(payload.thisVal, payload.args);
        });
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            emitter.next({
                thisVal: thisVal,
                args: args
            });
        };
    }
    Utils.debounce = debounce;
    function Debounce(duration) {
        var emitter = new rxjs_1.Subscriber();
        var observer = new rxjs_1.Observable(function (subscriber) {
            // @ts-ignore
            emitter = subscriber;
        })
            .pipe(operators_1.debounceTime(duration));
        return function (target, propertyKey, descriptor) {
            // 封装执行函数
            var method = descriptor.value;
            observer.subscribe(function (payload) {
                // @ts-ignore
                method.apply(payload.thisVal, payload.args);
            });
            // @ts-ignore
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                // @ts-ignore
                emitter.next({
                    thisVal: this,
                    args: args
                });
            };
            return descriptor;
        };
    }
    Utils.Debounce = Debounce;
    // 用于sort的比较函数
    function compare(v1, v2, desc) {
        if (v1 > v2) {
            return desc ? -1 : 1;
        }
        else if (v1 < v2) {
            return desc ? 1 : -1;
        }
        else {
            return 0;
        }
    }
    Utils.compare = compare;
    // 搜索匹配
    function match(search, values) {
        var search_sp = search.split(' ').map(function (s) { return s.trim().toLowerCase(); }).filter(function (s) { return !!s; });
        // 一旦任何一个值不匹配search_sp，返回false
        if (search_sp.length === 0) {
            return true;
        }
        return !search_sp.some(function (s) {
            // 所有搜索参数都不匹配返回true，存在匹配则返回false
            return !values.some(function (v) {
                // 检查匹配
                switch (typeof v) {
                    case "number":
                        return convert_1.Convert.parseInt(s) === v;
                    case "string":
                        return v.toLowerCase().indexOf(s) > -1;
                }
            });
        });
    }
})(Utils || (Utils = {}));
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map